import React from "react";
import {Box} from "@mui/system";
import _ from "lodash";
import styles from "../../../voteMainStyles";
import ResponseContent from "./ResponseContent";
import {
    hasResponseOptions,
    responseField,
    responseFieldState
} from "../../../../../utilities/ConversationUtils";

export default function ResponseContainer({responseOptions, isScrollComplete, editedResponseObj, editedSubjectObj, msgSourceName}) {
    const responseOptionArr = _.isEmpty(responseOptions) ? [{}] : responseOptions;
    const responseFieldResult = responseField(responseOptionArr);
    const hasRespOptions = hasResponseOptions(responseOptionArr);

    const Content = ({responseOptions}) => {
        if (responseFieldResult === responseFieldState.NONE) {
            return <Box sx={style.noResponseContainer}>No response found</Box>;
        }
        return <ResponseContent
            responseOptions={responseOptions}
            isScrollComplete={isScrollComplete}
            editedResponseObj={editedResponseObj}
            editedSubjectObj={editedSubjectObj}
            msgSourceName={msgSourceName}
        />;
    }

    return (
        <Box sx={styles.responsePanelRoot}>
            <Box sx={styles.heading}>{`Response${hasRespOptions ? 's' : ''}`}</Box>
            <Box sx={styles.panelContent}>
                <Box sx={styles.responseScrollArea}>
                    <Box sx={{marginBottom: '10px'}}>
                        <Content responseOptions={responseOptionArr}/>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

const style = {
    noResponseContainer: {
        fontSize: '15px',
        color: '#0C2728',
        textAlign: 'left',
        fontFamily: 'LarsseitRegular',
        border: '1px solid #DCE2E3',
        p: '10px',
        borderRadius: '5px'
    }
}